import React, { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { showStores, updateStore } from "../../../MyApi/stores";
import { Spinner } from "reactstrap";
import StatusBadge from "../../UI/statusBadge";

const UserStoreStatusCard = ({ storeId }) => {
  const { data, refetch } = useQuery(["showStores", storeId], () =>
    showStores(storeId),
  );
  const stores = data?.data?.Store || {};

  const { is_closed } = stores;

  const [isStoreClosed, setIsStoreClosed] = useState(is_closed);
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ["updateStoreStatus"],
    mutationFn: (postData) => updateStore(postData, storeId),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      refetch();
      queryClient.invalidateQueries("showStores");
    },
  });

  const handleChangeStatus = (e) => {
    const checked = e.target.checked;
    const formData = new FormData();
    setIsStoreClosed(checked);
    formData.append("store[is_closed]", checked ? 0 : 1);
    formData.append("_method", "PUT");
    mutation.mutate(formData);
  };

  return (
    <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2 me-2">
            <div >
     <div className="fw-bold font14 ">
       تغيير حالة تشغيل المتجر
        </div>
        <div className="d-flex align-items-center gap-2">
            <StatusBadge
            style={{padding:"0px",fontSize:"12px"}}
              status={!is_closed ? "active" : ""}
              statusLabel={!is_closed ? "متاح الان" : "غير متاح"}
            />
               {mutation.isLoading ? (
          <Spinner size="sm" />
        ) : (
          <label className="switch m-0"   >
            <input
        
              type="checkbox"
              onChange={handleChangeStatus}
              checked={!is_closed}
            />
            <span className="slider round "  style={{height:"20px"}}></span>
          </label>
        )}  
        </div>
            </div>
   

    
      </div>
    
      
    </div>
  );
};

export default UserStoreStatusCard;
